import React from 'react';
import { useNavigate } from 'react-router-dom';
import BookingStepper from './components/BookingStepper';
import BookingNavigation from './components/bookingNavigation/BookingNavigation';
import BookingSteps from './components/bookingSteps/BookingSteps';
import './Booking.scss';
import { TicketBookingProvider } from '../../../contexts/ticketBookingContext/TicketBookingContext';
import BookingTitle from './components/BookingTitle';
import TicketBookingDrawer from '../../components/drawers/ticketSearchDrawers/ticketBookingDrawer/TicketBookingDrawer';
import useQuery from '../../../hooks/useQuery';
import isStringJson from '../../../../utils/functions/isJson';
import BookingTimer from './components/BookingTimer';
import useTranslation from '../../../hooks/translation/useTranslation';

function Booking() {
  const { currentLanguage } = useTranslation();
  const query = useQuery();
  const navigate = useNavigate();
  let bookingData;

  const guid = query.get('guid');
  const seatFormation = query.get('seatFormation');
  switch (seatFormation) {
    case 'auto':
    case 'select':
    case 'book':
    case 'completeBooking':
      if (!guid || !isStringJson(sessionStorage.getItem(guid))) {
        navigate('/ka/search');
      } else {
        bookingData = JSON.parse(sessionStorage.getItem(guid));
      }
      break;
    default:
      navigate(`/${currentLanguage}/search`);
      break;
  }
  return (
    <TicketBookingProvider bookingData={bookingData}>
      <div className="flex flex-col lg:grid lg:grid-cols-7 gap-[60px]">
        <div className="flex flex-col gap-10 col-span-7 lg:col-span-5">
          <BookingTitle />
          <BookingTimer className="!justify-end !flex lg:!hidden" />
          <BookingStepper />
          <BookingSteps />
        </div>
        <div className="hidden lg:block lg:col-span-2">
          <BookingNavigation />
        </div>
        <TicketBookingDrawer />
      </div>
    </TicketBookingProvider>
  );
}

export default Booking;
